<template>
  <v-container fluid class="container--style">
    <div>
      <v-snackbar class="new-alert" v-model="alert" :timeout="timeout" :color="alertType" top="top">
        {{this.alertMessage}}
        <v-icon color="white" flat @click="alert = false">close</v-icon>
      </v-snackbar>
    </div>
    <v-layout justify-end>
      <v-flex md12 lg12 xs12 sm12 xl12>
        <v-flex md10 lg10 xs10 sm10 xl10>
          <v-layout>
            <h2>{{this.area}}</h2>
          </v-layout>
          <v-card>
            <v-card-title>
              <v-layout>
                <v-btn
                  style="margin-top:2%"
                  color="#1c345d"
                  @click="edit = true"
                  :disabled="($session.getAll().puedeEditar != true)"
                >Agregar Documentación</v-btn>
              </v-layout>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="anexos" :search="search">
              <template v-slot:items="props">
                <td width="70%" class="text-xs-left">{{ props.item.nombreVisible }}</td>
                <td width="30%" class="text-xs-center">
                  <v-btn
                    small
                    color="#90d2f8"
                    v-on:click="downloadFile(props.item.path,props.item.nombre,false)"
                  >
                    <v-icon color="#1c345d" dark>save_alt</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="($session.getAll().puedeEditar == true)"
                    small
                    color="#90d2f8"
                    v-on:click="getAnexoABorrar(props.item)"
                  >
                    <v-icon color="#1c345d" dark>delete</v-icon>
                  </v-btn>
                </td>
              </template>
              <template v-slot:no-results>
                <v-alert
                  :value="true"
                  color="error"
                  icon="warning"
                >La búsqueda de "{{ search }}" no arroja resultados.</v-alert>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-dialog v-model="edit" width="700px" persistent>
      <template v-slot:activator="{ on }"></template>
      <v-card class="new-card">
        <v-card-title>
          <span class="headline">Agregar Documentación</span>
        </v-card-title>
        <v-layout>
          <v-layout align-center justify-center>
            <v-flex md9 lg9 xs9 sm9>
              <v-layout>
                <v-flex md12 lg12 xs12 sm12>
                  <label class="left" for="sel1">Nombre de Archivo</label>
                  <input v-model="nombreArchivo" type="text" class="form-control" id="usr" />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-text-field
                  color="#1c345d"
                  label="Cargar documento"
                  @click="pickFile()"
                  v-model="FileName"
                  prepend-icon="attach_file"
                  :disabled="disabled"
                ></v-text-field>
                <input
                  color="#1c345d"
                  type="file"
                  id="file"
                  ref="myFiles"
                  style="display: none"
                  @change="previewFiles()"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
          <v-btn color="#394049" flat="flat" @click="submitFile()">Subir Archivo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="eliminar" width="500">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title>
          <span class="headline">¿Está seguro de querer eliminar el archivo {{anexo.nombreVisible}}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#ec6a12" flat="flat" @click="eliminar = false">No, cancelar</v-btn>
          <v-btn color="#394049" flat="flat" @click="erase(anexo.id)">Sí, eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editComentario" width="700px" persistent>
      <template v-slot:activator="{ on }"></template>
      <v-card class="new-card">
        <v-card-title>
          <span class="headline">Agregar observación</span>
        </v-card-title>
        <v-layout justify-center>
          <v-flex md10 lg10 xs10 sm10>
            <textarea v-model="content" type="text" class="form-control" rows="4" id="usr" />
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#ec6a12" flat="flat" @click="editComentario = false">Cerrar</v-btn>
          <v-btn color="#394049" flat="flat" @click="editLinea()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Nombre del Archivo",
          value: "nombreVisible"
        },
        {
          text: "Acciones",
          sortable: false
        }
      ],
      area: "",
      etapa: {},
      nEtapa: 0,
      eliminar: false,
      anexo: {},
      path1: "",
      path2: "",
      nombreArchivo: "",
      editComentario: false,
      edit: false,
      content: "",
      anexos: [],
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      alertType: "",
      alertMessage: "",
      alert: false,
      timeout: 4000,
      docExiste: false,
      idDoc: "",
      path: "",
      disabled: false,
      file: "",
      fileToUpload: "",
      FileName: ""
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      if (this.$route.params.id == "8") this.area = "Gestión";
      if (this.$route.params.id == "9") this.area = "Pregrado";
      if (this.$route.params.id == "10") this.area = "Postgrado";
      if (this.$route.params.id == "11") this.area = "Investigación";
      if (this.$route.params.id == "12") this.area = "Vinculación con el medio";
      if (this.$route.params.id == "13") this.area = "Otros";
      if (this.$route.params.id == "14")
        this.area = "Informe de Autoevaluación";
      if (this.$route.params.id == "15")
        this.area = "Documentos acreditación 2014";


      this.verificaPath();
      this.getEtapa();
    }
  },
  created() {
    //console.log(this.$route.fullPath);
    if (this.$route.params.id == "8") this.area = "Gestión";
    if (this.$route.params.id == "9") this.area = "Pregrado";
    if (this.$route.params.id == "10") this.area = "Postgrado";
    if (this.$route.params.id == "11") this.area = "Investigación";
    if (this.$route.params.id == "12") this.area = "Vinculación con el medio";
    if (this.$route.params.id == "13") this.area = "Otros";
    if (this.$route.params.id == "14") this.area = "Informe de Autoevaluación";
    if (this.$route.params.id == "15")
        this.area = "Documentos acreditación 2014";
    this.verificaPath();
    this.getEtapa();
  },

  methods: {
    getEtapa() {
      axios
        .get(process.env.ROOT_API + "/etapa/getEtapa", this.auth)
        .then(response => {
          //console.log("ESTADO");
          //console.log(this.nEtapa);
          //console.log(response.data);
          //console.log(response.data["comentarioEtapa" + this.nEtapa]);
          this.etapa = response.data;
          console.log(response.data);
          console.log(this.nEtapa);
          this.content = response.data["comentario" + this.nEtapa];
          console.log(this.content);
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },
    editLinea() {
      this.etapa["check" + this.nEtapa] = true;
      this.etapa["comentario" + this.nEtapa] = this.content;
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaGral?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          alert("Comentario añadido correctamente");
          this.editComentario = false;
        })
        .catch(error => {
          alert(error.response.data);
        });
    },
    getAnexoABorrar(item) {
      this.anexo = item;
      this.eliminar = true;
    },
    erase(id) {
      axios
        .delete(
          process.env.ROOT_API + "/documento/eraseDoc?idCap=" + id,
          this.auth
        )
        .then(response => {
          //this.anexos = response.data;
          this.eliminar = false;
          this.getAnexos();
          alert(response.data);
        })
        .catch(error => {
          alert(error.response.data);
        });
    },

    verificaPath() {
      console.log(this.$route.params.id);

      if (this.$route.params.id > 7 && this.$route.params.id < 16) {
        this.path1 = "/documento/getByTipo?tipo=" + this.$route.params.id;
        this.path2 =
          "/documento/createDoc?tipo=" + this.$route.params.id + "&nombre=";
        this.nEtapa = parseInt(this.$route.params.id);
      }
      this.getAnexos();
    },
    getAnexos() {
      axios
        .get(process.env.ROOT_API + this.path1, this.auth)
        .then(response => {
          //console.log("ANEXOS");
          //console.log(response.data);
          this.anexos = response.data;
          //console.log(this.anexos);
        })
        .catch(error => {
          //console.log("ERROR ANEXOS");

          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },

    pickFile() {
      //console.log("entrando a pick file");
      //console.log(this.$refs["myFiles"]);
      this.$refs["myFiles"].click();
    },
    previewFiles() {
      //console.log(index);
      this.fileToUpload = this.$refs["myFiles"].files[0];
      //console.log(this.$refs["myFiles"].files);
      //console.log(this.filess);
      this.FileName = this.$refs["myFiles"].files[0].name;
    },
    submitFile() {
      let formData = new FormData();
      var name = this.nombreArchivo;
      var email = this.$session.getAll().email;
      //console.log("indice: " + index);

      formData.append("file", this.fileToUpload);
      //console.log("FORM DATA");
      //console.log(formData);
      axios
        .post(
          process.env.ROOT_API + this.path2 + this.nombreArchivo,
          formData,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          //console.log("SUCCESS!!");
          //console.log(response.data);
          //this.path = response.data;
          //this.filesDge.dge[index]["saved"] = "si";
          //this.filesDge.dge[index]["path"] = response.data[0];
          //this.filesDge.dge[index]["name"] = response.data[1];
          alert(
            "Archivo: " + response.data.nombre + " fue cargado exitosamente."
          );
          this.getAnexos();
          this.FileName = "";
          this.edit = false;
          //No fuerza la recarga
          //this.$router.push({path: `/capitulo/${this.$route.params.id}/informacion`})
        })
        .catch(error => {
          //console.log("FAILURE!!");
          //console.log(error.response.data);
          alert(error.response.data);
        });
    },

    downloadFile(pathFile, nameFile, view) {
      var pathCorrecto = this.convertPath(pathFile);
      //console.log(pathFile);
      //console.log("Descargando archivo ....");
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathCorrecto,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          if (view) {
            this.forceFileDownload2(response, nameFile);
          } else {
            this.forceFileDownload(response, nameFile);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },

    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    forceFileDownload2(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      window.open(url, "_blank");
    },
    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    }
  }
};
</script>

<style scoped>
.new-card {
  height: auto;
}

.new-alert {
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.v-card__title.color {
  font-size: 12px;
  padding: 5px;
}

.v-card__text {
  background-color: #474a4e;
  padding: 1%;
  text-align: justify;
}
.comentario {
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 2%;
  margin-bottom: 2%;
  border-radius: 5%;
}

.container--style {
  margin-top: 7%;
  padding: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}
</style>




// WEBPACK FOOTER //
// src/components/dca/documentosPost/DocumentosArea.vue